import React from 'react';
import { Post } from '../types';
import Reveal from './Reveal';
import styles from '../styles/Writing.module.css';

export interface WritingProps {
  posts: Post[];
  /** DOM id for scroll / anchors (unique per instance) */
  sectionId: string;
  title: string;
}

const Writing: React.FC<WritingProps> = ({ posts, sectionId, title }) => (
  <section className={styles.section} id={sectionId} aria-label={title}>
    <Reveal>
      <div className={styles.header}>
        <h2 className={styles.title}>{title}</h2>
      </div>
    </Reveal>

    <div className={styles.card}>
      {posts.map((post, i) => {
        const rowStyle = {
          borderBottom:
            i < posts.length - 1 ? '1px solid rgba(0,0,0,0.07)' : 'none',
        };
        const cells = (
          <>
            <span className={styles.postDate}>{post.date}</span>
            <span className={styles.postName}>{post.title}</span>
            <span className={styles.postTime}>{post.time}</span>
          </>
        );
        return (
          <Reveal key={`${sectionId}-${i}-${post.title}`} delay={i * 0.08}>
            {post.href ? (
              <a
                href={post.href}
                className={styles.postRow}
                style={rowStyle}
                target="_blank"
                rel="noopener noreferrer"
              >
                {cells}
              </a>
            ) : (
              <button type="button" className={styles.postRow} style={rowStyle}>
                {cells}
              </button>
            )}
          </Reveal>
        );
      })}
    </div>
  </section>
);

export default Writing;
